/**
 * A validation run's lifecycle, one value per observable hop. Code-owned and closed,
 * so an enum rather than administrator data. `FAILED` is reached only when the run
 * could not be set up at all - never because rules came back `NEEDS_REVIEW`, and
 * never because one evaluation dead-lettered.
 */
export enum RuleValidationStatus {
	REQUESTED = 'requested',
	SENT_TO_VALIDATOR = 'sent_to_validator',
	COMPLETED = 'completed',
	FAILED = 'failed',
}

/**
 * One audit record's outcome. `PENDING` means the record exists but no verdict has
 * been written; it is also what makes the run-completion guard a simple `NOT EXISTS`.
 * `NEEDS_REVIEW` is recorded - never `PASS` - whenever the evaluator could not reach
 * a verdict.
 */
export enum RuleCheckOutcome {
	PENDING = 'pending',
	PASS = 'pass',
	FAIL = 'fail',
	NEEDS_REVIEW = 'needs_review',
}

/** What a validation run was requested against. */
export enum RuleValidationTargetType {
	FILE = 'file',
	CAMPAIGN = 'campaign',
	WORK_ORDER = 'work_order',
}

/** The kind of content one audit record judged. */
export enum RuleValidationSubjectType {
	FILE = 'file',
	MESSAGE = 'message',
}
